module.exports = __webpack_public_path__ + "static/media/clubhouse-game.b9bde92a.mov";